module.exports = __webpack_public_path__ + "media/images/apple-icon-152x152-6086c05d.png";